import createReadonlyDictionary from "stores/templates/ReadonlyDictionaryStore";

import api from "services/api";
import { MSURL } from "utils/ms";

const FoodDayTypeDictionary = createReadonlyDictionary({
  fetch: async function() {
    return await api.get(
      `/food/api/v1/days-types`,
      undefined,
      undefined,
      MSURL,
    );
  },
});

export default FoodDayTypeDictionary.create();
